var _defs, _rect, _g, _g2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKampdagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    role: "img",
    "aria-label": "Kampdag",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pitch",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3cbe4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#157a28"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "url(#pitch)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0.08)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 16,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    width: 16,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    width: 16,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    width: 16,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 96,
    height: 88,
    rx: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 64,
    x2: 112,
    y2: 64
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 40h18v-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 88h-18v20"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 3.5,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKampdagIcon);
export default __webpack_public_path__ + "static/media/kampdagIcon.6165930fdbd9970464e6b1287004162e.svg";
export { ForwardRef as ReactComponent };